'use strict';

function aweDocsListIcons(el) {
    var settings = { valueNames: ['doc-list-class'], page: 750 };
    var list = new List(el, settings);
}

function aweDocsBackgroundHeight() {
    var resizeTimer;

    var backgroundHeight = $(window).height() - 80;

    $('.background').height(backgroundHeight);

    $(window).on('resize', function(e) {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function() {
            $('.background').height(backgroundHeight);
        }, 250);
    });
}
$(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });